import {callApiLayDanhSachThongBao, callApiMarkAsReadAll, callApiUpdateDaXemThongBao,} from "@/api/thong-bao";

const layDanhSachThongBao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachThongBao(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_THONG_BAO", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const updateDaXemThongBao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateDaXemThongBao(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const markAsReadAll = () => {
  return new Promise((resolve, reject) => {
    callApiMarkAsReadAll()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export default {
  markAsReadAll,
  layDanhSachThongBao,
  updateDaXemThongBao,
};
